// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareDataViewListContainer__list-container-df3f4a {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ShareDataView/ShareDataViewListContainer/ShareDataViewListContainer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AACF","sourcesContent":[".list-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: auto;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-container": `ShareDataViewListContainer__list-container-df3f4a`,
	"listContainer": `ShareDataViewListContainer__list-container-df3f4a`
};
module.exports = ___CSS_LOADER_EXPORT___;
